// extracted by mini-css-extract-plugin
module.exports = {"viewport":"_10K7Y"};